module.exports = __webpack_public_path__ + "img/vacina-sesi-logo-azul.4421cc21.svg";